import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bandcamp': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM296.2 334.1l84.7-156.1h-181l-84.7 156.1h181z'
      }
    ]
  }
})
